import React, { useMemo, useState } from "react";

import CustomSelect from "../../../../components/select/Select";
import { getLinkedFirm } from "../../../../sessionStorage/sessionStorage";
import { useSearchTagsQuery } from "../../../../slices/ContactTagsSlice";
import { SelectOptionType } from "../../../../types/types";

type ContactTagsSelectorProps = {
  value: SelectOptionType[];
  onChange: (tags: SelectOptionType[]) => void;
};

export const ContactTagsSelector: React.FC<ContactTagsSelectorProps> = ({
  value,
  onChange,
}) => {
  const [search, setSearch] = useState("");
  const { data: tags = [], isLoading } = useSearchTagsQuery({
    orgId: getLinkedFirm()?.orgId || "",
    query: search || null,
  });

  const tagOptions = useMemo<SelectOptionType[]>(
    () =>
      tags.map((tag) => ({
        value: tag.id,
        label: tag.tagName,
      })),
    [tags],
  );

  const mergedOptions = useMemo(() => {
    const optionIds = new Set(tagOptions.map((option) => option.value));
    const missingSelectedOptions = value.filter(
      (option) => !optionIds.has(option.value),
    );

    return [...missingSelectedOptions, ...tagOptions];
  }, [tagOptions, value]);

  return (
    <CustomSelect
      isMulti
      options={mergedOptions}
      value={value}
      onChange={(newValue) => onChange(newValue as SelectOptionType[])}
      inputValue={search}
      onChangeInput={setSearch}
      placeholder={"Search tags..."}
      isLoading={isLoading}
      withMenu
      menuPlacement={"top"}
      selectStyle={{
        size: "md",
        fullWidth: true,
        fitChips: true,
        listHeight: "180px",
      }}
    />
  );
};
